/* RESPONSIBLE TEAM: team-inbox-management */
import JSONAPIAdapter from '../json-api';

export default JSONAPIAdapter.extend({});
